import React from "react";
import {
  TouchableOpacity,
  View,
  Text,
  StyleSheet,
  TextInput,
  ScrollView,
  TouchableWithoutFeedback,
  Keyboard,
  Button,
} from "react-native";
import { HeaderBackButton } from "@react-navigation/elements";

import { Feather } from "@expo/vector-icons";
import DefaultText from "../../../components/text/DefaultText";
import DefaultTextLight from "../../../components/text/DefaultTextLight";
import * as authActions from "../../../store/actions/auth";
import { useDispatch } from "react-redux";
import ProfileMainScreen from "./ProfileMainScreen";

const EmailSentScreen = (props) => {
  const dispatch = useDispatch();
  const { inputEmail } = props.route.params;
  React.useLayoutEffect(() => {
    props.navigation.setOptions({
      headerLeft: () => (
        <HeaderBackButton
          onPress={() => {
            props.navigation.navigate("ProfileAuthScreen", {
              isSignup: true,
            });
          }}
        />
      ),
    });
  }, [props.navigation]);
  return (
    <View style={styles.screen}>
      <Feather name="mail" size={40} color="white" style={styles.Icon} />
      <DefaultText style={styles.Prompt}>Email Has Been Sent!</DefaultText>
      <DefaultTextLight style={styles.DidntReceiveEmail}>
        Didn't receive email?
      </DefaultTextLight>
      <TouchableOpacity
        style={styles.buttonContainer}
        onPress={() => {
          dispatch(authActions.resetPassword(inputEmail)).then(() => {
            props.navigation.replace("EmailSentScreen", {
              inputEmail: inputEmail,
            });
          });
        }}
      >
        <DefaultText>Resend Email</DefaultText>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  Prompt: {
    fontSize: 30,
    marginBottom: "20%",
  },

  Icon: {
    marginBottom: 36,
  },

  DidntReceiveEmail: {},

  buttonContainer: {
    marginTop: 20,
    paddingVertical: 16,
    width: "80%",
    borderWidth: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "black",
    borderColor: "white",
    marginBottom: 10,
  },
});

export default EmailSentScreen;
